import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import helpCenterUrl from 'modules/core/lib/helpCenterUrl'
import i18n from 'modules/core/lib/i18n'

import illustration from 'modules/surveys/components/Analytics/_BlankSlate/illustration.svg'
import IllustratedBlankSlate from 'modules/surveys/components/IllustratedBlankSlate'

const AnonymousBlankSlate = () => (
  <Box borderRadius={{ all: 'abs008' }} background="grey000White" paddingBottom="s64">
    <IllustratedBlankSlate
      illustration={illustration}
      title={i18n.t('surveys.form.tabs.not_enough_answers.title')}
      description={i18n.t('surveys.form.tabs.not_enough_answers.description')}
      linkHref={helpCenterUrl('anonymous_surveys')}
      linkText={i18n.t('surveys.form.tabs.not_enough_answers.link')}
    />
  </Box>
)

export default AnonymousBlankSlate
